import { isProjectAssignedThroughTeam } from "@utils/data-display";

/**
 * Builds the "not-allowed" updates that exclude projects the member was assigned
 * to through a team (no direct/explicit role) from a bulk action, tagging them
 * with an explanatory message shown in the confirmation dialog.
 */
export function getTeamAssignedExclusions(projects, message) {
  return projects.filter(isProjectAssignedThroughTeam).map(project => ({
    id: project.id,
    changes: {
      status: "not-allowed",
      message
    }
  }));
}